import type { DiscoveryTheme } from "./types";

/** Reviewed listing IDs from the existing static/portable catalogue seeds,
 *  kept in step with the API's `discover_categories.ts`. */
export const DISCOVERY_THEMES: readonly DiscoveryTheme[] = [
  {
    id: "games",
    label: "Games",
    listingIds: ["discover-2048", "discover-hextris", "discover-hexgl"],
  },
];
